import { render, staticRenderFns } from "./manageExternalFileControl.vue?vue&type=template&id=63ccebc7&scoped=true"
import script from "./index?vue&type=script&lang=js&external"
export * from "./index?vue&type=script&lang=js&external"
import style0 from "./manageExternalFileControl.vue?vue&type=style&index=0&id=63ccebc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ccebc7",
  null
  
)

export default component.exports